

import axios from "axios";
import { useAuth } from "../navigation/AuthProvider";
import { BACKEND_URL } from "../constants";




export const add_new_worksession = async ({ company, user, projectId, workSessionData, timeSchemaId}) => {

    if(!user || !company) return void null
    if(!timeSchemaId) return alert("Du måste skapa ett schema innan du kan lägga till pass")
    
    
    const { data } = await axios.post(`${BACKEND_URL}/add-worksession-to-draft`, {
        companyId: company._id,
        userId: user._id,
        workSessionData,
        projectId,
        timeSchemaId
    }, {withCredentials: true})

    return data
}


export const edit_worksession = async ({ user, company, updatedFields, worksession, projectId, timeSchemaId}) => {
    if(!user || !company) return void null


    const { data } = await axios.put(`${BACKEND_URL}/edit-worksession-draft`, {
        userId: user._id,
        companyId: company._id,
        updatedFields,
        shiftId: worksession._id,
        projectId,
        timeSchemaId
    }, { withCredentials: true})

    return data
}



export const remove_worksession = async ({ user, company, worksession, timeSchemaId}) => {
    if(!user || !company) return void null

    const { data } = await axios.delete(`${BACKEND_URL}/remove-worksession-from-draft`, {
        data: {
            userId: user._id,
            companyId: company._id,
            shiftId: worksession._id,
            timeSchemaId
        }
    }, { withCredentials: true})

    return data
}

export const copy_week_schedule = async ({
  user,
  company,

  sourceWeek,
  targetWeek,

  settings,

  timeSchemaId,
}) => {

  if (
    !user ||
    !company ||
    !sourceWeek ||
    !targetWeek ||
    !timeSchemaId
  ) {
    return alert(
      "Kunde inte skicka datan till servern"
    );
  }

  const { data } = await axios.post(

    `${BACKEND_URL}/copy-week-schedule`,

    {
      userId: user._id,

      companyId: company._id,

      sourceWeek,
      targetWeek,

      settings,

      timeSchemaId,
    },

    {
      withCredentials: true,
    }
  );

  return data;
};

export const bulk_delete_worksessions = async ({
  user,
  company,
  timeSchemaId,
  shiftIds = [],
  dates = [],
}) => {
  if (!user || !company) return void null;

  const { data } = await axios.post(
    `${BACKEND_URL}/bulk-delete-worksessions`,
    {
      userId: user._id,
      companyId: company._id,
      timeSchemaId,
      shiftIds,
      dates,
    },
    { withCredentials: true }
  );

  return data;
};



export const create_new_timeSchema = async ({timeSchemaName, user, company}) => {
    if(!user || !company || !timeSchemaName) return alert("Kunde inte skicka förfrågan till servern")

    const { data } = await axios.post(`${BACKEND_URL}/add-new-timeschema`, {
        userId: user._id,
        companyId: company._id,
        timeSchemaName
    }, { withCredentials: true })

    return data
}


export const delete_existing_timeSchema = async ({timeSchemaId, user, company}) => {
    if(!user || !company || !timeSchemaId) return alert("Kunde inte skicka förfrågan till servern")

    const { data } = await axios.post(`${BACKEND_URL}/delete-timeschema`, {
        userId: user._id,
        companyId: company._id,
        timeSchemaId
    }, { withCredentials: true })

    return data
}



export const change_selected_timeSchema = async ({selectedTimeSchema, user, company}) => {
    if(!user || !company) return alert("Kunde inte skicka förfrågan till servern")

    const { data } = await axios.post(`${BACKEND_URL}/change-selected-timeschema`, {
        userId: user._id,
        companyId: company._id,
        selectedTimeSchemaId: selectedTimeSchema
    }, { withCredentials: true })

    return data
}


export const publish_draft_schedule = async ({user, company, timeSchema, newPublishDate}) => {
    if(!user || !company || !timeSchema || !newPublishDate) return alert("Kunde inte skicka datan till servern")

    const { data } = await axios.post(`${BACKEND_URL}/publish-draft-schedule`, {
        userId: user._id,
        companyId: company._id,
        timeSchemaId: timeSchema,
        newPublishDate
    }, {withCredentials: true})

    return data
}



export const recall_draft_schedule = async ({user, company, timeSchema, newRecallDate}) => {
    if(!user || !company || !timeSchema || !newRecallDate) return alert("Kunde inte skicka datan till servern")

    const { data } = await axios.post(`${BACKEND_URL}/recall-draft-schedule`, {
        userId: user._id,
        companyId: company._id,
        timeSchemaId: timeSchema,
        newRecallDate
    }, {withCredentials: true})

    return data
}



